import axios from "axios";
import { defaultValue, IProvince } from "../shared/model/province.model";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  FETCH_PROVINCE_LIST: "province/FETCH_PROVINCE_LIST",
  FETCH_PROVINCE: "province/FETCH_PROVINCE",
  RESET: "province/RESET",
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IProvince>,
  entity: defaultValue,
  totalItems: 0,
};

export type ProvinceState = Readonly<typeof initialState>;

// RECUCER

export const provinceReducer = (
  state: ProvinceState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROVINCE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROVINCE):
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROVINCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROVINCE):
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.FETCH_PROVINCE_LIST):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROVINCE):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external/provinces";
export const getEntities = () => {
  return {
    type: ACTION_TYPES.FETCH_PROVINCE_LIST,
    payload: axios.get<IProvince>(apiUrl),
  };
};

export const getEntity = (id: number) => {
  //   const requestUrl = `${apiUrl}/${id}`;
  //   return {
  //     type: ACTION_TYPES.FETCH_PROVINCE,
  //     payload: axios.get<IApplication>(requestUrl),
  //   };
};
export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
